/**
 * Partial config sent to the live preview endpoint while editing.
 *
 * Includes the optional in-flight Voluum flow override so the backend can
 * walk the unsaved Standard tab draft (toggled paths, weight tweaks) instead
 * of the persisted live flow. Excluding `flowOverride` falls back to the
 * persisted Voluum flow as before.
 */

import type {
  FlowOptimizerConfig,
  VoluumFlowUpdate,
} from '@trafficpulse/shared';

export type PreviewDraftBody = Partial<FlowOptimizerConfig> & {
  flowOverride?: VoluumFlowUpdate;
};

export function buildPreviewDraft(
  draft: FlowOptimizerConfig,
  flowOverride?: VoluumFlowUpdate | null,
): PreviewDraftBody {
  const body: PreviewDraftBody = {
    flowId: draft.flowId,
    mode: draft.mode,
    enabled: draft.enabled,
    killSwitch: draft.killSwitch,
    intervalMin: draft.intervalMin,
    minWeight: draft.minWeight,
    maxWeight: draft.maxWeight,
    standardJson: draft.standardJson,
    excludeRules: draft.excludeRules,
    formula: draft.formula,
  };
  if (flowOverride) body.flowOverride = flowOverride;
  return body;
}
